// extracted by mini-css-extract-plugin
export default {"product":"K-","image_carousel":"L-","main_gallery":"M-","personalized_badge":"N-","greens_badge":"O-","arrows":"P-","slide":"Q-","thumbnail_gallery":"R-","swiper-slide":"S-","learn_more":"T-","product_info":"U-","description_wrapper":"V-","checklist":"W-","checklistItem":"X-","delivery_freq":"Y-","tooltip_button":"Z-","key_benefits":"a0","benefit_item":"b0","ingredients":"c0","ingredient_item":"e0","active_slide":"f0","benefits_list":"g0","checkmark":"h0"};
    if(module.hot) {
      // 1713361654878
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  